import React from "react";
import { Modal } from "../../CustomModal/Modal";
import { Strings } from "../../../Resources/Strings/i18n";
import Button from "@material-ui/core/Button";
import ReactCustomFlagSelect from "react-custom-flag-select";
import FLAG_SELECTOR_OPTION_LIST from "../../../Countries";
import TextField from "@material-ui/core/TextField";
import GoogleLogin from "react-google-login";
import { GOOGLE_WEB_CLIENT_ID } from "./../../../Communication/Constants";
import ic_google from "../../../Resources/Images/ic_google@2x.png";

function CustomModal(props) {
  return (
    <div className="customModal">
      <Modal
        show={props.showCustomModal}
        handleClose={props.hideModal}
        parent={"login"}
      >
        {
          <div className="customModalContainer">
            <div className="customModal">
              <div className="customModalTitle">
                <div id="headingTitle">
                  {props.showVerifyEmailModal ? (
                    <div>
                      <span id="errorText">{Strings("Verify1") + " "}</span>
                      {Strings("EmailAddressPlaceholder").toLowerCase()}
                    </div>
                  ) : props.emailModal ? (
                    <div>
                      <span id="errorText">{Strings("ADD") + " "}</span>
                      {Strings("EmailAddressPlaceholder").toLowerCase()}
                    </div>
                  ) : (
                    <div>
                      <span id="errorText">{Strings("ADD") + " "}</span>
                      {Strings("MobileNumberPlaceHolder").toLowerCase()}
                    </div>
                  )}
                 
                </div>
              </div>
              <div className="customModalContentContainer">
                <div className="customModalContent">
                  {props.emailModal ? (
                    <div>{Strings("addEmailAddressOnAccount")}</div>
                  ) : (
                    <div>{Strings("AddMobileNumberOnAccount")}</div>
                  )}

                  {props.emailModal || props.showVerifyEmailModal ? (
                    <div className="emailSection">
                      <TextField
                        required
                        autoComplete="off"
                        type="email"
                        id="standard-basic"
                        label={Strings("EmailPlaceHolder")}
                        name={Strings("EmailPlaceHolder")}
                        value={props.emailID}
                        error={props.emailIDError}
                        onChange={(event) => {
                          props.setEmailValue(event.target.value);
                        }}
                        onFocus={props.onEmailFocus}
                      />
                    </div>
                  ) : (
                    <div className="mobileNumberSection">
                      <div className="callingCodePicker">
                        <label className={"callingCodeLabel"}>
                          {Strings("Country")}
                        </label>
                        <ReactCustomFlagSelect
                          tabIndex={"1"}
                          id={props.callingCode}
                          name={"callingCode"}
                          value={
                            props.selectedCountry && props.selectedCountry.id
                          }
                          showSearch={true}
                          showArrow={true}
                          animate={true}
                          optionList={FLAG_SELECTOR_OPTION_LIST}
                          customStyleContainer={{
                            border: "none",
                            fontSize: "12px",
                          }}
                          customStyleSelect={{
                            width: "100%",
                            height: "25px",
                            padding: "0px 20px",
                          }}
                          customStyleOptionListContainer={{
                            margin: "0px",
                            maxHeight: "155px",
                            overflow: "auto",
                            width: "130px",
                          }}
                          onChange={(CallingCode) => {
                            props.setCallingCode(CallingCode);
                          }}
                        />
                      </div>
                      <div className="mobileNumberBlock">
                        <div>
                          <TextField
                            required
                            id="standard-basic"
                            autoComplete={"off"}
                            className="mobileNumberField"
                            // onChange={this.onMobileChangeHandler}
                            onChange={(event) => {
                              let regex = /^[0-9\b]+$/; // allow only numbers [0-9]
                              if (regex.test(event.target.value)) {
                                if (event.target.value.length < 16) {
                                  props.setMobileValue(event.target.value);
                                }
                              } else {
                                props.setMobileValue("");
                              }
                            }}
                            value={props.mobileNumberValue}
                            error={props.mobileNumberError}
                            label="Mobile Number"
                            onFocus={props.onMobileFocus}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              {props.showVerifyEmailModal ? (
                <Button
                  className="customModalBtn"
                  onClick={() => {
                    props.sendDirectToOTP();
                  }}
                >
                  {Strings("verify")}
                </Button>
              ) : (
                <Button
                  className="customModalBtn"
                  onClick={() => {
                    props.emailModal
                      ? props.validateEmail()
                      : props.validateOtp();
                  }}
                >
                  {Strings("AddPhoneBtnText")}
                </Button>
              )}
            </div>
            {props.emailModal || props.showVerifyEmailModal ? (
              <div className="googleSignIn">
                <GoogleLogin
                  className="GoogleSignInBtn"
                  clientId={GOOGLE_WEB_CLIENT_ID}
                  buttonText="Login"
                  onSuccess={(responseGoogle) => {
                    //responseGoogle.disconnect();
                    props.onSuccessGoogleSignUp(responseGoogle, () => {
                      responseGoogle.disconnect();
                    });
                  }}
                  onFailure={(responseGoogle) => {
                    alert(false)
                    // responseGoogle.disconnect();
                  }}
                  cookiePolicy={"single_host_origin"}
                >
                  <span className="googleLetter">
                    <img src={ic_google} alt="ic_google" />
                  </span>
                  {Strings("Google").toUpperCase()}
                </GoogleLogin>
              </div>
            ) : null}
          </div>
        }
      </Modal>
    </div>
  );
}

export default CustomModal;
